<template>
  <div>
    <component :is="currentManagementContent"></component>
  </div>
</template>
<script>
import MyBooks from '@components/MyBooks'
import MyPapers from '@components/MyPapers'
import MyBookshelf from '@components/MyBookshelf'
import MyBooklib from '@components/MyBookLib'
import VideoRecommendation from '@components/VideoRecommendation'
import QuestionnaireData from '@components/QuestionnaireData'
import ChargeManagement from '@components/ChargeManagement'
import InvoiceManagement from '@components/InvoiceManagement'
import MyLinkword from '@components/MyLinkword'
import DefaultEdit from '@components/DefaultEdit'
import PaperArticleLib from '@components/PaperArticleLib'
import PaperAiVideos from '@components/PaperAiVideos'
import PaperManagement from '@components/PaperManagement'
import MyTopics from '@components/MyTopics'
import SpecialWordManagement from '@components/SpecialWordManagement'
export default {
  name: 'management',
  data() {
    return {}
  },
  computed: {
    currentManagementContent() {
      return this.$store.state.manage.currentManageContent
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  mounted() {
    if (this.currentManagementContent.indexOf('Paper') > -1) {
      document.title = '数字报纸'
    } else if (this.currentManagementContent === 'ChargeManagement' || this.currentManagementContent === 'ChargeManagement' || this.currentManagementContent === 'InvoiceManagement') {
      document.title = '内容运营'
    }
  },
  components: {
    MyBooks,
    MyBookshelf,
    MyBooklib,
    VideoRecommendation,
    MyLinkword,
    DefaultEdit,
    MyPapers,
    QuestionnaireData,
    ChargeManagement,
    InvoiceManagement,
    PaperArticleLib,
    PaperAiVideos,
    PaperManagement,
    MyTopics,
    SpecialWordManagement
  }
}
</script>
